export default __webpack_public_path__ + "static/img40h-8473a7ab1c9dd0d2e0b73f23ecbe39ae.jpg";